// Membership.jsx
import React from "react";
import { motion } from "framer-motion";
import Title from "../components/ui/Title";
import SectionTitle from "../components/ui/SectionTitle";
import PrimaryButton from "../components/ui/PrimaryButton";
import CardContainer from "../components/ui/CardContainer";

export default function Membership() {
  return (
    <motion.div
      className="p-6 max-w-4xl mx-auto space-y-6 text-text-body"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Title>Membership</Title>

      <p>
        Pentru cei care vor mai mult – nu din presiune, ci din chemare.
        Spațiul de membership este un sanctuar viu pentru reflecții lunare,
        conversații sincere și sprijin constant pe calea trăirii designului.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
        <CardContainer>
          <SectionTitle>🌱 Susținător</SectionTitle>
          <p className="text-sm text-body">
            Pentru cei care vor să susțină spațiul JunkFree Human Design.
            Acces la reflecțiile lunare în format audio și newsletter dedicat.
          </p>
        </CardContainer>

        <CardContainer>
          <SectionTitle>🌀 Explorator</SectionTitle>
          <p className="text-sm text-body">
            Pentru cei care vor să aprofundeze trăirea designului. Acces complet
            la reflecții, resurse aplicate și sesiuni ocazionale de grup.
          </p>
        </CardContainer>

        <CardContainer className="sm:col-span-2">
          <SectionTitle>🔥 Aliniat în profunzime</SectionTitle>
          <p className="text-sm text-body">
            Pentru cei gata să se dedice transformării personale prin design.
            Include acces la toate resursele + întâlniri exclusive în cerc restrâns.
          </p>
        </CardContainer>
      </div>

      <div className="pt-6 text-sm text-body border-t">
        <p>
          Înscrierea se face prin Patreon, iar contribuția ta susține munca vie
          și spațiul curat al acestei călătorii. Fără obligații. Doar prezență.
        </p>
      </div>

      <div className="mt-8 text-center">
        <PrimaryButton
          as="a"
          href="https://www.patreon.com/c/HumanDesignJunkFree"
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg px-6 py-3 rounded-full"
        >
          Intră în comunitate pe Patreon
        </PrimaryButton>
      </div>
    </motion.div>
  );
}
